<template>
    <template v-if="props.headerId">
        <Teleport :to="props.headerId">
            <template v-for="item in props.buttons" :key="item.name || item.title">
                <template v-if="item.type === 'kebab'">
                    <KebabMenu
                        :leftAuto="!locale.rtl"
                        :rightAuto="locale.rtl"
                        :secondary="true"
                        size="size-s"
                        @toggle="data[item.name || item.title] = !data[item.name || item.title]"
                    >
                        <template v-slot:trigger>
                            <Button 
                                :icon="item.icon"
                                :sprite="item.sprite"
                                :name="item.name"
                                :title="item.title"
                                :class="{
                                    active: data[item.name || item.title],
                                    invert: props.detail,
                                    tertiary: props.tertiary,
                                    'size-s': item.name,
                                    'size-m': !item.name
                                }"
                                :disabled="item.disabled"
                                :kebabTrigger="true"
                            />
                        </template>
                        <template v-slot>
                            <ul>
                                <li v-for="subitem in item.items"
                                    :key="subitem.code"
                                    @click="item.onClick(subitem)"
                                >
                                    <span>{{ subitem.name }}</span>
                                </li>
                            </ul>
                        </template>
                    </KebabMenu>
                </template>
                <template v-if="item.type === 'button'">
                    <Button 
                        :icon="item.icon"
                        :sprite="item.sprite"
                        :name="item.name"
                        :title="item.title"
                        :disabled="item.disabled"
                        :class="{
                            'size-s': item.name,
                            'size-m': !item.name,
                            invert: props.detail,
                            tertiary: props.tertiary
                        }"
                        @click="item.onClick"
                    />
                </template>
            </template>
            <template v-if="props.clearable && props.count">
                <Button :title="t(`common.unselect`)"
                    class="size-m"
                    icon="close" sprite="navigation"
                    :class="{
                        invert: props.detail,
                        tertiary: props.tertiary
                    }"
                    @click="emit('clear')"
                />

                <span class="selected">
                    {{ t(`pluralization.${props.pluralizationCode}s.selected`, {
                        count: props.count,
                        [props.pluralizationCode]: t(`pluralization.${props.pluralizationCode}s.${props.pluralizationCode}`, props.count)
                    }) }}
                </span>
            </template>
        </Teleport>
    </template>
</template>

<script setup>
    import { useI18n } from 'vue-i18n';
    import { reactive } from 'vue';
    import KebabMenu from '🔗/components/ui/KebabMenu.vue';
    import Button from '🔗/components/ui/Button.vue';
    // import stores from '@/stores';

    const locale = stores.locale();
    const { t } = useI18n();

    const emit = defineEmits(['clear']);

    const props = defineProps({
        buttons: { type: Array, default: () => ([]) },
        clearable: { type: Boolean, default: false },
        pluralizationCode: { type: String, default: '' },
        headerId: { type: String, default: '' },
        detail: { type: Boolean, default: true },
        tertiary: { type: Boolean, default: true },
        count: { type: [Number, null], default: null }
    });

    const data = reactive({
    })
</script>


<style lang="scss" scoped>
    .selected {
        font: var(--font-caption);
        color: var(--white-500);
        min-width: 110px;
        text-align: right;
    }
</style>
